/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import {
  React,
} from 'react';
import BundleDetailPopup from '../../../screens/Bundle/BundleDetailPopup';
import FineGrainedPermissionsInfo from '../../../screens/Admin/FineGrainedPermissions/FineGrainedPermissionsInfo';



const openAsset = (fileId) => {
  const url = `${window.location.origin}/#/assetDetail/${fileId}`;
  window.open(url, '_blank');
};

function parseCustomString(str) {
  // Remove the outer braces and split by commas
  const entries = str?.slice(1, -1).split(', ');
  const result = {};

  // Process each entry
  entries.forEach((entry) => {
    const [key, value] = entry.split('=').map((item) => item.trim());

    // Convert value to a number if possible, otherwise treat it as a string
    result[key] = value;
  });

  return result;
}

function getDescription(assetDescription) {
  if (assetDescription?.Version && assetDescription?.Description) {
    return {
      version: assetDescription.Version,
      description: assetDescription.Description,
    };
  }

  if (assetDescription?.version && assetDescription?.description) {
    return assetDescription;
  }

  return parseCustomString(assetDescription);
}

export default function NewDeploymentHeader({
  objectsToDeploy,
}) {
  const isBundle = objectsToDeploy?.length > 0 && objectsToDeploy[0].type === 'bundle';
  return (
    <div className="w-full max-w-full">
      <div className="mx-2 max-w-full">
        {isBundle && (
          <>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Bundle to deploy
            </label>

            <div className="bg-white rounded-xl shadow-sm overflow-x-auto mt-1">
              <div className="min-w-full">
                <div className="bg-white divide-y divide-gray-200">
                  {objectsToDeploy && objectsToDeploy.length > 0 && (
                    <div className="bg-gray-50 px-3 py-4 sm:px-6">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                        <div className="flex-shrink-0 text-sm text-gray-900">
                          ✅ {objectsToDeploy[0].title}
                        </div>
                        <div className="flex-1 text-sm text-gray-900 break-words">
                          {objectsToDeploy[0].releaseDescription?.description || objectsToDeploy[0].description || ' '}
                        </div>
                        <div className="flex-shrink-0">
                          <BundleDetailPopup releaseID={objectsToDeploy[0].releaseID} />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
      
      <div className="mx-2 max-w-full">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {isBundle ? 'Assets in the bundle' : 'Assets to deploy'}
        </label>

        <FineGrainedPermissionsInfo
          open={false}
          onClose={() => { }}
          style={{ margin: 24 }}
        />

        <div className="bg-white rounded-xl shadow-sm overflow-x-auto mt-1">
          <div className="min-w-full">
            <div className="bg-white divide-y divide-gray-200">
              {objectsToDeploy && objectsToDeploy.length > 0 && objectsToDeploy.map((objectToDeploy) => (
                isBundle && objectToDeploy?.fileIDs?.length > 0 ? (
                  objectToDeploy.fileIDs.map((assetInBundle) => (
                    <div key={assetInBundle.fileID} className="bg-gray-50 px-3 py-4 sm:px-6">
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-4 items-start">
                        <div className="text-sm text-gray-900 break-words">
                          <span className="font-medium">Version:</span> ✅ {assetInBundle.assetDescription ? getDescription(assetInBundle.assetDescription)?.version : '-'}
                        </div>
                        <div className="text-sm text-gray-900 break-all">
                          <span className="font-medium sm:hidden">File ID:</span> {objectToDeploy.fileID}
                        </div>
                        <div className="text-sm text-gray-900 break-words col-span-1 sm:col-span-1 lg:col-span-1">
                          <span className="font-medium sm:hidden">Description:</span> {assetInBundle.assetDescription ? getDescription(assetInBundle.assetDescription)?.description : '-'}
                        </div>
                        <div className="flex justify-start lg:justify-end">
                          <button 
                            onClick={() => openAsset(assetInBundle.fileID)}
                            className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                            title="Open asset"
                          >
                            <span className="sm:hidden">Open</span>
                            <ArrowTopRightOnSquareIcon className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div key={objectToDeploy.fileID} className="bg-gray-50 px-3 py-4 sm:px-6">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-4 items-start">
                      <div className="text-sm text-gray-900 break-words">
                        <span className="font-medium sm:hidden">Version:</span> ✅ v.{objectToDeploy.assetDescription ? objectToDeploy.assetDescription.Version : '-'}
                      </div>
                      <div className="text-sm text-gray-900 break-words col-span-1 lg:col-span-1">
                        <span className="font-medium sm:hidden">Description:</span> {objectToDeploy.assetDescription?.Description || ' '}
                      </div>
                      <div className="flex justify-start lg:justify-end">
                        <button 
                          onClick={() => openAsset(objectToDeploy.fileID)}
                          className="text-blue-600 hover:text-blue-800 flex items-center gap-1"
                          title="Open asset"
                        >
                          <span className="sm:hidden">Open</span>
                          <ArrowTopRightOnSquareIcon className="w-5 h-5" />
                        </button>
                      </div>
                    </div>
                  </div>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
NewDeploymentHeader.propTypes = {
  objectsToDeploy: PropTypes.array.isRequired,
};
